/**
 * Created by mac on 2/25/20
 */

const FogBlock = function (id, fogs) {
    cleverapps.EventEmitter.call(this);
    this.id = cleverapps.castType(id);
    this.fogs = fogs;
    this.options = fogs && fogs.config[id] || {};
    this.money = this.options.money;

    this.tiles = [];

    this.state = FogBlock.UNAVAILABLE;

    this.onGetView = function () {};
};

FogBlock.prototype = Object.create(cleverapps.EventEmitter.prototype);
FogBlock.prototype.constructor = FogBlock;

FogBlock.prototype.findTile = function (x, y) {
    const p = cc.p(x, y);
    for (let i = 0; i < this.tiles.length; i++) {
        if (cc.pointEqualToPoint(this.tiles[i], p)) {
            return this.tiles[i];
        }
    }

    if (cc.pointEqualToPoint(this.balloonTile, p)) {
        return this.balloonTile;
    }
};

FogBlock.prototype.getKey = function () {
    return this.id;
};

FogBlock.prototype.calcTilesBorders = function () {
    if (this.isBordersCalculated) {
        return;
    }

    BorderRenderer.place(
        this.tiles,
        (borders, cell) => {
            const fogTile = Map2d.currentMap.getFog(cell.x, cell.y);
            const images = fogTile.getFogBundle().frames;
            const type = fogTile.getFogKey();
            borders.forEach((border) => {
                const image = images[`fog_${border.name}_png_${type}`];
                if (image) {
                    fogTile.borders.push({
                        res: image,
                        dir: border.name
                    });
                }
            });
        }
    );

    this.isBordersCalculated = true;
};

FogBlock.prototype.isMoney = function () {
    return this.money;
};

FogBlock.prototype.isSoftMoney = function () {
    return this.isMoney() && this.options.soft;
};

FogBlock.prototype.isSpecial = function () {
    return this.options.special;
};

FogBlock.prototype.isSilentUnblock = function () {
    return this.options.silentUnblock && this.state < FogBlock.NOTREADY;
};

FogBlock.prototype.isFree = function () {
    return !this.options.price;
};

FogBlock.prototype.getDecorations = function () {
    if (!this._decorations) {
        this._decorations = FogDecorations.enabled
            ? FogDecorations.generate(this)
            : {};
    }
    return this._decorations;
};

FogBlock.prototype.getDecorationForTile = function (tile) {
    return this.getDecorations()[`${tile.x}_${tile.y}`];
};

FogBlock.prototype.isTreasureMapTarget = function () {
    return this.options.treasureMapTarget;
};

FogBlock.prototype.click = function (pointOfInterest) {
    let scrollToFogHead = false;
    if (this.state !== FogBlock.UNAVAILABLE) {
        const conditions = this.listNotFinishedConditions();
        if (conditions.length) {
            this.displayCondition(conditions[conditions.length - 1]);
        }
        if (!this.isMoney()) {
            if (this.state === FogBlock.CANTOPEN) {
                this.displayWandsCondition();
            }
            if (this.state === FogBlock.CANOPEN) {
                cleverapps.centerHint.createTextHint(Messages.get("Fog.clear.clearNow"));
            }
        }
        for (let i = 0; i < this.tiles.length; i++) {
            const tile = this.tiles[i];
            tile.onClick();
            if (!scrollToFogHead) {
                let fakeUnit = tile.getFakeUnit();
                if (fakeUnit) {
                    fakeUnit = fakeUnit.head ? fakeUnit.head : fakeUnit;
                    const scrollToHead = Families[fakeUnit.code].units[fakeUnit.stage].scrollToHead;
                    scrollToFogHead = scrollToFogHead || (scrollToHead && scrollToHead[cleverapps.meta.selectedLocationId()]);
                }
            }
        }
        scrollToFogHead = scrollToFogHead && !this.isMoney();
    } else if (pointOfInterest) {
        const unitData = Families[pointOfInterest.code].units[pointOfInterest.stage];
        if (unitData.temporary) {
            pointOfInterest = cleverapps.clone(pointOfInterest, true);
            pointOfInterest.stage++;
        }
        cleverapps.centerHint.createTextHint(Messages.get(cleverapps.skins.getSlot("pointOfInterestFogText", pointOfInterest) || "Fog.pointOfInterest", { name: cleverapps.unitsLibrary.getUnitName(pointOfInterest) }));
        scrollToFogHead = unitData.scrollToHead && unitData.scrollToHead[cleverapps.meta.selectedLocationId()];
    }
    if (scrollToFogHead) {
        FogBlock.scrollToHead(this);
    }
};

FogBlock.prototype.hintTapBlocker = function () {
    this.trigger("hintTapBlocker");
};

FogBlock.prototype.displayCondition = function (condition) {
    if (condition.level) {
        cleverapps.centerHint.createTextHint(Messages.get("Fog.clear.levelCondition", { level: condition.level }));
    }
    if (condition.hero) {
        this.displayHeroCondition(condition);
    }
    if (condition.familyLastUnit) {
        this.displayCastleCondition(condition.familyLastUnit);
    }
    if (condition.unit) {
        this.displayUnitCondition(condition.unit);
    }
};

FogBlock.prototype.displayItemCondition = cleverapps.throttle(500, (params) => {
    InfoView.CloseInfo();

    if (typeof Map2dLocation !== "undefined") {
        Map2dLocation.currentLocation.showLargestGroup(params);
    }
});

FogBlock.prototype.displayHeroCondition = function (condition) {
    const unit = {
        code: condition.hero,
        stage: Unit.getAllStagesTargets(condition.hero).pop().stage
    };

    const text = [
        { text: `${Messages.get("CenterHint.merge.begins")} x3` },
        { icon: UnitView.getUnitImage({ code: unit.code, stage: unit.stage - 1 }, { preferStatic: true }) },
        { text: `${Messages.get("CenterHint.merge.ends")} ` },
        { icon: UnitView.getUnitImage(unit, { preferStatic: true }) }
    ];

    if (cleverapps.unitsLibrary.getCurrentHero() === condition.hero) {
        this.displayItemCondition({
            itemCode: condition.hero,
            text
        });
    } else {
        cleverapps.centerHint.createTextHint(text);
    }
};

FogBlock.prototype.displayCastleCondition = function (familyLastUnit) {
    this.displayItemCondition({
        itemCode: familyLastUnit.code,
        pointOfInterest: true,
        text: Messages.get("Fog.clear.buildCastle", { castle: cleverapps.unitsLibrary.getUnitName(familyLastUnit) }),
        finger: this.options.finger
    });
};

FogBlock.prototype.displayUnitCondition = function (unit) {
    this.displayItemCondition({
        itemCode: unit.code,
        itemStage: unit.stage,
        text: Messages.get("Fog.clear.unitCondition", { unit: cleverapps.unitsLibrary.getUnitName(unit) }),
        finger: this.options.finger
    });
};

FogBlock.prototype.displayWandsCondition = function () {
    this.displayItemCondition({
        itemCode: "wands",
        text: Messages.get("Fog.clear.notEnoughWands", { wands: this.getOpenPrice() - this.fogs.wands })
    });
};

FogBlock.prototype.setState = function (newState) {
    const openAutomatically = this.isFree() && newState === FogBlock.CANOPEN && this.options.openAutomatically;
    if (openAutomatically && !Map2d.currentMap.fogs.initStageRunned) {
        this.fogs.wantsCalcFogStates = true;
    }
    if (this.state !== newState || openAutomatically) {
        const update = function (silent) {
            this.updateState(newState, silent);
            this.trigger("updateBlocker", newState, silent);
            this.trigger("updateState", newState, silent);
        }.bind(this);

        const isTutorialActive = cleverapps.tutorial.isActive() || (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation && Map2dLocation.currentLocation.tutorial && Map2dLocation.currentLocation.tutorial.isActive());
        if ((this.state < newState && Map2d.currentMap.fogs.initStageRunned && [FogBlock.UNAVAILABLE, FogBlock.NOTREADY, FogBlock.CANTOPEN].includes(this.state))
            || (openAutomatically && Map2d.currentMap.fogs.initStageRunned)) {
            if (isTutorialActive || this.isSilentUnblock()) {
                update();
                return;
            }
            if (cleverapps.focusManager.isFocused()) {
                this.fogs.wantsCalcFogStates = true;
                return;
            }
            if (this.state !== FogBlock.CANTOPEN || !this.onGetView()) {
                this.scrollAndUpdateStateAction(newState);
                return;
            }
        }

        update(true);
    } else if (newState === FogBlock.NOTREADY) {
        this.trigger("updateBlocker", newState, true);
    }
};

FogBlock.prototype.updateState = function (newState, silent, silentBalloon) {
    this.state = newState;

    for (let i = 0; i < this.tiles.length; i++) {
        this.tiles[i].updateState(this.state, silent);
    }
    if (this.balloonTile && this.balloonTile.fake) {
        this.balloonTile.updateState(this.state, silentBalloon || silent);
    }
};

FogBlock.prototype.onChangeWandsAmount = function () {
    if (this.state === FogBlock.CANTOPEN || this.state === FogBlock.CANOPEN) {
        this.setState(this.canOpen() ? FogBlock.CANOPEN : FogBlock.CANTOPEN);
        this.trigger("wandsChanged");
    }
};

FogBlock.prototype.calcState = function () {
    let newState = FogBlock.UNAVAILABLE;

    if (this.isAvailable()) {
        newState = FogBlock.NOTREADY;
        if (this.isReady()) {
            newState = FogBlock.CANTOPEN;
            if (this.canOpen()) {
                newState = FogBlock.CANOPEN;
            }
        } else {
            this.blockerConditions = this.listNotFinishedConditions();
        }
    }

    this.setState(newState);
};

FogBlock.prototype.add = function (x, y, options) {
    if (this.findTile(x, y)) {
        return;
    }

    let FogTileClass = FogTile;
    if (cleverapps.config.editorMode && typeof EditorFogTile !== "undefined") {
        FogTileClass = EditorFogTile;
    }

    const head = options && options.head;
    const fake = options && options.fake;

    const tile = new FogTileClass(x, y, this, options);
    if (head) {
        this.head = tile;
    }
    if (!fake) {
        this.tiles.push(tile);
    }
    return tile;
};

// eslint-disable-next-line no-unused-vars
FogBlock.prototype.remove = function (x, y) {
    
};

FogBlock.prototype.addBalloon = function (x, y) {
    const tile = this.findTile(x, y) || this.add(x, y, { fake: true });
    this.balloonTile = tile;

    let FogBalloonClass = FogBalloon;
    if (cleverapps.config.editorMode && typeof EditorFogBalloon !== "undefined") {
        FogBalloonClass = EditorFogBalloon;
    }

    const balloon = this.balloon = new FogBalloonClass(tile, this);
    tile.addBalloon(balloon);
    tile.onUpdateState(this.state, true);
};

FogBlock.prototype.removeBalloon = function () {
    if (this.balloon) {
        delete this.balloon;

        const balloonTile = this.balloonTile;
        delete this.balloonTile;

        balloonTile.removeBalloon();
        balloonTile.onUpdateState(this.state, true);
    }
};

FogBlock.prototype.getBalloon = function () {
    return this.balloon;
};

FogBlock.prototype.getDelayBeforeOpening = function () {
    return FogBlock.DELAY_BEFORE_OPENING[cleverapps.config.name] || 0;
};

FogBlock.prototype.getOpenAnimationDuration = function () {
    let openDelay = 0;
    this.tiles.forEach((tile) => {
        openDelay = Math.max(openDelay, tile.getOpenDelay() + tile.getOpenDuration());
    });

    return openDelay;
};

FogBlock.prototype.prepareOpenOrderForDispelling = function () {
    const pseudo = PseudoRandom.GET("fogblock");
    pseudo.seed(this.id);
    const tiles = pseudo.shuffle(this.tiles);

    let openDelay = 0;

    tiles.forEach((tile, index) => {
        tile.openDelay = openDelay;

        openDelay += 200 / (0.6 * index + 1);
    });
};

FogBlock.prototype.prepareOpenOrderForWind = function () {
    const tiles = this.tiles.slice();

    tiles.sort((a, b) => a.x - b.x);

    let x, openOrder = -1;
    tiles.forEach((tile) => {
        if (x !== tile.x) {
            x = tile.x;
            openOrder++;
        }

        tile.openDelay = openOrder * 180;
    });
};

FogBlock.prototype.prepareOpenDelay = function () {
    if (!this.head) {
        return;
    }

    const styles = cleverapps.styles.FogTileView[this.head.getFogType()];
    if (styles && styles.dispelling) {
        this.prepareOpenOrderForDispelling();
    } else if (styles && styles.whirlwind) {
        this.prepareOpenOrderForWind();
    } else if (!styles || !styles.groundStateOnly) {
        this.prepareOpenOrder();
    }
};

FogBlock.prototype.prepareOpenOrder = function () {
    const tiles = this.tiles.slice();

    tiles.sort((a, b) => a.x - b.x);

    let x, line = -1;
    tiles.forEach((tile) => {
        if (x !== tile.x) {
            x = tile.x;
            line++;
        }

        tile.line = line % 2;
    });

    tiles.sort((a, b) => a.y - b.y);

    const pass = function (currentLine) {
        let y, openOrder = -1;
        tiles.forEach((tile) => {
            if (tile.line === currentLine) {
                if (y !== tile.y) {
                    y = tile.y;
                    openOrder++;
                }

                tile.openDelay = openOrder * 180;
            }
        });
    };

    pass(0);
    tiles.reverse();
    pass(1);
};

FogBlock.prototype.getOpenPrice = function () {
    return this.convertHardPrice(this.options.price);
};

FogBlock.prototype.convertHardPrice = function (price) {
    return price;
};

FogBlock.prototype.getBubbles = function () {
    return this.options.bubbles || [];
};

FogBlock.prototype.giftBubbles = function () {
    const pocket = new Pocket("main");
    pocket.addUnits(this.getBubbles());
};

FogBlock.prototype.isAvailable = function () {
    if (this.options.available === false || this.options.debugMode === true && !cleverapps.config.debugMode) {
        return false;
    }

    if (this.options.discover) {
        return this.isDiscovered();
    }

    return this.options.parentFogId === undefined || this.fogs.isOpened(this.options.parentFogId);
};

FogBlock.prototype.isDiscovered = function () {
    if (!Map2d.currentMap.blockedGrounds) {
        return false;
    }

    const selfMap = {};
    this.tiles.forEach((tile) => {
        selfMap[`${tile.x}_${tile.y}`] = true;
    });

    return this.tiles.some((tile) => ISO_NEIGHBORS.some((dir) => {
        const x = tile.x + dir.x;
        const y = tile.y + dir.y;

        const unit = Map2d.currentMap.getUnit(x, y);
        return !selfMap[`${x}_${y}`] && !Map2d.currentMap.getFog(x, y) && Map2d.currentMap.isGround(x, y) && (!unit || !unit.isGrounded());
    }));
};

FogBlock.prototype.scrollAndUpdateStateAction = function (newState) {
    const state = this.state;

    cleverapps.focusManager.display({
        focus: "scrollToFogAndUpdateState",
        keepControls: true,
        actions: [
            function (f) {
                cleverapps.timeouts.setTimeout(f, 300);
            },

            function (f) {
                if (
                    newState === FogBlock.NOTREADY
                    || this.options.noScrollOnOpen === true && newState === FogBlock.CANOPEN
                ) {
                    f();
                } else {
                    FogBlock.scrollToHead(this, f);
                }
            }.bind(this),

            function (f) {
                this.trigger("updateBlocker", newState);

                if (state < FogBlock.CANTOPEN && FogBlock.CANTOPEN <= newState) {
                    cleverapps.timeouts.setTimeout(f, this.getDelayBeforeOpening());
                } else {
                    f();
                }
            }.bind(this),

            function (f) {
                this.updateState(newState, false, true);

                if (state < FogBlock.CANTOPEN && FogBlock.CANTOPEN <= newState) {
                    this.hideBalloon(true);
                    cleverapps.timeouts.setTimeout(f, this.getOpenAnimationDuration());
                } else {
                    f();
                }
            }.bind(this),

            function (f) {
                this.trigger("updateState", newState);
                cleverapps.timeouts.setTimeout(f, 300);
            }.bind(this),

            function (f) {
                if (this.state < FogBlock.CANTOPEN) {
                    f();
                    return;
                }

                if (this.isFree() && !this.fogs.isOpened(this.id)) {
                    this.unlock();
                }

                if (this.isMoney()) {
                    this.showBalloon();
                }

                f();
            }.bind(this),

            function (f) {
                f();
                this.fogs.calcFogStatesStage();
            }.bind(this)
        ]
    });
};

FogBlock.prototype.showBuyWindow = function () {
    if (this.isMoney()) {
        cleverapps.focusManager.display({
            focus: "BuyFogWindow",
            action: function (f) {
                this.createBuyWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }.bind(this)
        });
    }
};

FogBlock.prototype.createBuyWindow = function () {
    if (cleverapps.config.name === "hustlemerge") {
        Map2d.currentMap.focusOnUnit(this.head, {
            zoom: {
                duration: 0.5,
                zoom: 0.8
            },
            allowScrollWithFocus: true
        });
    }

    new BuyFogWindow(this);
};

FogBlock.prototype.getProduct = function () {
    if (!this.isMoney() || this.isSoftMoney()) {
        return;
    }

    return Product.CreateByHardPrice(this.getOpenPrice(), {
        type: "fogs",
        fogId: this.id,
        expedition: cleverapps.meta.selectedLocationId()
    }, ["island1", "island2", "island5", "island10", "island15", "island20", "island30", "island45"]);
};

FogBlock.prototype.onBuy = function (f, success) {
    if (success) {
        this.unlock();

        const locationId = cleverapps.meta.selectedLocationId();
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.SPENT.FOGBUY}-${locationId}-${this.id}`);

        cleverapps.metrics.logEvent(cleverapps.EVENTS.SPENT.FOG);

        f(true);
    } else {
        f(false);
    }
};

FogBlock.prototype.buy = function (f) {
    const product = this.getProduct();
    if (product) {
        product.buy((success) => {
            this.onBuy(f, success);
        });
        return;
    }

    this.onBuy(f, cleverapps.user.spendSoft(cleverapps.EVENTS.SPENT.PAY_ISLAND, this.getOpenPrice(), { source: this.onGetView() }));
};

FogBlock.prototype.getPriceTag = function () {
    const product = this.getProduct();
    if (product) {
        return product.getCurrentPrice();
    }

    return `@@ ${this.getOpenPrice()}`;
};

FogBlock.prototype.isReady = function () {
    if (cleverapps.environment.isEditorScene()) {
        return false;
    }
    return this.listNotFinishedConditions().length === 0;
};

FogBlock.prototype.canOpen = function () {
    if (this.isMoney()) {
        return true;
    }
    return this.getOpenPrice() <= this.fogs.wands;
};

FogBlock.prototype.listNotFinishedConditions = function () {
    const unfinished = [];

    if (cleverapps.config.editorMode || !this.options.conditions) {
        return unfinished;
    }

    const level = this.options.conditions.level;
    if (cleverapps.gameLevel && cleverapps.gameLevel.getLevel() < level) {
        unfinished.push({
            level
        });
    }

    const hero = this.options.conditions.hero;
    if (hero && !cleverapps.unitsLibrary.isHeroAvailable(hero)) {
        unfinished.push({
            hero
        });
    }

    const family = this.options.conditions.family;
    if (family) {
        cleverapps.toArray(family).forEach((family) => {
            const lastUnit = UnitsLibrary.LastStage(family);

            if (!cleverapps.unitsLibrary.isOpened(lastUnit)) {
                unfinished.push({
                    familyLastUnit: lastUnit
                });
            }
        });
    }

    const unit = this.options.conditions.unit;
    if (unit) {
        cleverapps.toArray(unit).forEach((unit) => {
            if (!cleverapps.unitsLibrary.isOpened(unit)) {
                unfinished.push({
                    unit,
                    hidden: unit.hidden
                });
            }
        });
    }

    return unfinished;
};

FogBlock.prototype.unlock = function (callback, silent) {
    callback = callback || function () {};

    if (this.options.exp) {
        typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation.addReward("exp", this.options.exp, this.head);
    }

    this.trigger("open");
    this.purge();

    this.head && this.head.onOpenFogBlock();

    const fogSource = this.isMoney() ? "fog_paid" : "fog";
    const expedition = cleverapps.meta.getSelectedLocation().locationConfig.isMain ? "main" : cleverapps.meta.selectedLocationId();

    for (let i = 0; i < this.tiles.length; i++) {
        this.fogs.getFakeUnits(this.tiles[i].x, this.tiles[i].y).forEach((unit) => {
            if (unit.head || !["rubies", "coins", "wands", "energy"].includes(unit.code)) {
                return;
            }

            cleverapps.metrics.logEvent(`${cleverapps.EVENTS.EARN.SPAWN}-${unit.code}${unit.stage}-${expedition}_${fogSource}`);
        });
    }

    for (let i = 0; i < this.tiles.length; i++) {
        this.tiles[i].onOpen(undefined, true);
        this.fogs.map2d.blockedGrounds.add(this.tiles[i].x, this.tiles[i].y);
    }
    this.trigger("open");
    if (this.balloonTile && this.balloonTile.fake) {
        this.balloonTile.open();
        this.balloonTile.animateOpen();
    }
    delete this.balloonTile;

    this.tiles = [];
    this.head = undefined;

    if (this.getBubbles().length > 0) {
        this.giftBubbles();
    }

    if (!this.isMoney()) {
        this.fogs.takeWands(this.getOpenPrice());
    }

    const data = { fog: this.id };
    Map2d.mapEvent(Map2d.OPENFOG, data);
    cleverapps.tutorial.trigger(Map2d.OPENFOG, data);

    this.fogs.open(this.id, () => {
        if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation.unitStories) {
            Map2dLocation.currentLocation.unitStories.onFogOpened(this.id);
        }
        callback();
    }, silent);

    if (this.id === "dragonIsland") {
        Map2d.mapEvent(Map2d.OPENDRAGON);
    }

    const location = cleverapps.meta.getSelectedLocation();
    if (!location.locationConfig.isMain) {
        const startTime = location.getStartTime();
        if (startTime < Date.now()) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.OPEN_FOG, { itemId: this.id });
            cleverapps.abExperiments.allLogEvent(cleverapps.EVENTS.OPEN_FOG, { eventsGroup: "fogs", itemId: this.id });

            const lastFogId = Object.keys(this.fogs.config).reverse().find((type) => {
                const region = this.fogs.map2d.regions[type];
                return region && region.positions && region.positions.length && type.match(/^fog\d+$/);
            });
            if (this.id === lastFogId) {
                cleverapps.metrics.logEvent(cleverapps.EVENTS.OPEN_FOG, { itemId: "last" });
                cleverapps.abExperiments.allLogEvent(cleverapps.EVENTS.OPEN_FOG, { eventsGroup: "fogs", itemId: "last" });
            }

            if (startTime > 0) {
                cleverapps.metrics.logEvent(cleverapps.EVENTS.OPEN_FOG_TIME, {
                    value: Math.floor((Date.now() - startTime) / 60 / 60 / 1000),
                    itemId: this.id
                });
            }
        }
    }
};

FogBlock.prototype.showBalloon = function (silent) {
    if (this.balloon) {
        this.balloon.show(silent);
    }
};

FogBlock.prototype.hideBalloon = function (silent) {
    if (this.balloon) {
        this.balloon.hide(silent);
    }
};

FogBlock.prototype.getConsoleInfo = function () {
    return {
        id: this.id,
        options: this.options,
        state: this.state
    };
};

FogBlock.prototype.isBorderTile = function (tileToCheck) {
    let amountNeighbours = 0;
    this.tiles.forEach((tile) => {
        if (Math.abs(tileToCheck.x - tile.x) + Math.abs(tileToCheck.y - tile.y) === 1) {
            amountNeighbours++;
        }
    });
    return amountNeighbours < 4;
};

// the fog of the receipt on the current map; paid fog ids repeat across maps, so the map must be the one it was bought on
FogBlock.RestoreFind = function (context) {
    const map2d = typeof Map2d !== "undefined" && Map2d.currentMap;
    if (!map2d) {
        return;
    }

    if (context.expedition && context.expedition !== cleverapps.meta.selectedLocationId()) {
        return;
    }

    const fogId = Fogs.ConvertFromOldName(map2d.fogs.config, context.fogId);
    return fogId ? { map2d, fogId } : undefined;
};

FogBlock.RestoreIsOwned = function (fog) {
    return fog.map2d.fogs.isOpened(fog.fogId);
};

// scroll to the fog, then open it as the buy does
FogBlock.RestoreGive = function (fog) {
    const fogBlock = fog.map2d.fogs.getBlockById(fog.fogId);

    cleverapps.focusManager.display({
        focus: "RestoreFog",
        stack: true,
        actions: [
            function (f) {
                FogBlock.scrollToHead(fogBlock, f);
            },

            function (f) {
                f = cleverapps.wait(2, f);

                fogBlock.onBuy(f, true);
                cleverapps.timeouts.setTimeout(f, 500);
            }
        ]
    });
};

FogBlock.scrollToHead = function (fogBlock, f) {
    if (fogBlock.head) {
        Map2d.currentMap.focusOnUnit(fogBlock.head, {
            allowScrollWithFocus: true
        });
    }
    if (f) {
        cleverapps.timeouts.setTimeout(f, cc.ScrollAction.SCROLL_TO_DURATION * 1000);
    }
};

FogBlock.UNAVAILABLE = 0;
FogBlock.NOTREADY = 1;
FogBlock.CANTOPEN = 2;
FogBlock.CANOPEN = 3;

FogBlock.DELAY_BEFORE_OPENING = {
    mergecraft: 500,
    wondermerge: 1200
};

Restorable.BY_TYPE["fogs"] = new Restorable({
    location: Restorable.LocationContextExpedition,
    find: FogBlock.RestoreFind,
    isOwned: FogBlock.RestoreIsOwned,
    give: FogBlock.RestoreGive
});
